import { For, Show } from "solid-js";

type Stat = { value: number; label: string };

type Props = {
  conference?: number;
  meetup?: number;
  onConnect?: number;
};

export function PresenceStats(props: Props) {
  const items = (): Stat[] =>
    (
      [
        { value: props.conference ?? 0, label: "Conference" },
        { value: props.meetup ?? 0, label: "Meetup" },
        { value: props.onConnect ?? 0, label: "On Connect" },
      ] satisfies Stat[]
    ).filter((row) => row.value > 0);

  return (
    <Show when={items().length}>
      <div class="presence-stats">
        <For each={items()}>
          {(row) => (
            <div class="presence-stat">
              <strong>{row.value}</strong>
              <span>{row.label}</span>
            </div>
          )}
        </For>
      </div>
    </Show>
  );
}
